import LinearProgress from "@mui/material/LinearProgress";
import React, {useEffect, useState, useRef} from "react";
import dashboardServices from "../../services/hoa-dashboard-api-service";
import datastore from "../../store/hoa-datastore";
import BillableItemsModal from "../billableItems-modal/billable-items-modal";
import Tooltip from '@mui/material/Tooltip';
import { Card, Container, IconButton, Modal, Button, TextField } from "@mui/material";
import { Edit } from '@mui/icons-material';
import { decodeNestedURI } from "../../utility/decode-url";
import CloseIcon from '@mui/icons-material/Close';
import DescriptionIcon from '@mui/icons-material/Description';
import JsonView from '@uiw/react-json-view';
import { getChange } from "../../utility/change-log";
import DownloadIcon from "@mui/icons-material/GetApp";
import InfoIcon from '@mui/icons-material/Info';
import { FilterList } from "@mui/icons-material";
import DeleteOutlineSharpIcon from '@mui/icons-material/DeleteOutlineSharp';
import Popover from '@mui/material/Popover';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import config from '../../hoa-config';
import dayjs from 'dayjs';
import CustomDateField from "../../Container/custom-date-field";

const hoaPath = 'hoa'
const toolbar = 64;
const filterComponent = 103;
const tabHeader = 48;
const tabHeading = 65;
const tableHeader = 57;
const responsiveHeight = toolbar + filterComponent + tableHeader + tabHeader + tabHeading + 1;

const tabSize = 7;
//["", "Entry ID", "Organization Name" "Billable Item", "Effective Date", "Timestamp", "Events", "Username", "Source ID", "Remarks", "Document Type", ""
const tabWidth = ["3%", "7%", "7", "7%", "7%", "9%", "10%", "8%", "7%", "7%", "7%", "7%", "7%", "7%", "3%"];
const changeStateTabWidth = ["10%", "15%"];

export default function HoaAppLogV2(props: any) {
	const buttonRef = useRef(null);
	const { type, isLogLoading, updateLogLoading, getCreatedLogs, setReloadFutureEffectiveDateLog, isOtherBillableItemsDisabled, height, appLogs, setAppLogs  } = props;
	const [isBillableItemsModal, setIsBillableItemsModal] = useState(false);
	const [selectedAppLogId, setSelectedAppLogId] = useState();
	const [selectedBillItem, setSelectedBillItem] = useState(null);
	const [linkedEntryId, setLinkedEntryId] = useState(null);
	const [evidenceLink, setEvidenceLink] = useState(null);
	const [documentType, setDocumentType] = useState(null);
	const [open, setOpen] = useState(false);
	const [selectedLog, setSelectedLog] = useState(null);
	const [docModalOpen, setDocModalOpen] = useState(false);
	const [sourceDocuments, setSourceDocuments] = useState(null);
	const [sourceId, setSourceId] = useState('');
	const [isVerified, setIsVerified] = useState(null);
	const [sourceDocumentType, setSourceDocumentType] = useState('');
	const [anchorEl, setAnchorEl] = useState(null);
	const [startDate, setStartDate] = useState(null);
	const [endDate, setEndDate] = useState(null);

	const [documentId, setDocumentId] = useState("")
	const [isDocumentIdVerified, setIsDocumentIdVerified] = useState(false)
	const [documentViewModal, setDOcumentViewModal] = useState(false)
	const [documentData, setDocumentData] = useState([])

	async function handleScroll(e:any){
		const options = {
			...(datastore.selectedOrganization?.id ? { 'orgId': datastore.selectedOrganization?.id } : {}),
			...(documentType ? { 'documentType': documentType } : {}),
			...(startDate ? { 'startEffectiveDate': startDate } : {}),
			...(endDate ? { 'endEffectiveDate': endDate } : {})
		  }
		const bottom = e.target.scrollHeight - e.target.scrollTop - 1 <= e.target.clientHeight;
		if (bottom && !appLogs.isLastPage) {
			await getCreatedLogs(appLogs.pageNumber, options);
		}
	}

	const handleClose = () => {
		setOpen(false);
	}

	const handleDocModalClose = () => {
		setSourceDocuments(null);
		setDocModalOpen(false);
	}

	const handleDocModalOpen = (e: any, row: any) => {
		e.stopPropagation();
		if(row && row?.documents) {
			setSourceDocuments(row);
			setDocModalOpen(true);
		}
	}

	const changeStateModal = (log: any) => {
		if(type === 'Hoa' || type === 'Property'){
			setOpen(true);
			setSelectedLog(log);
		}
	}

	const appLogClicked = (e: any, appLog:any) => {
		e.stopPropagation();
		if(appLog) {
			setSelectedAppLogId(appLog.objectId);
			setSelectedBillItem(appLog.billItem);
			setLinkedEntryId(appLog.linkedEntryId);
			setEvidenceLink(appLog.evidenceLink);
			setSourceId(appLog.sourceId);
			setDocumentId(appLog.documentId);
			setDocumentType(appLog.documentType);
			setIsVerified(appLog.documents);
			setSourceDocumentType(appLog.sourceDocumentType)
			setIsBillableItemsModal(true);
		}
	}

	const updateHoaApplog = async () => {
		if(selectedAppLogId && selectedBillItem) {
			let copyOfLogs = JSON.parse(JSON.stringify(appLogs.data));
			let selectedAppLogIndex = -1;
			let selectedAppLog = copyOfLogs.find((log: any, index: number) => {
				if(log.objectId === selectedAppLogId){
					selectedAppLogIndex = index;
					return log;
				}
			});

			if(selectedAppLog) {
				selectedAppLog.billItem = selectedBillItem;
				selectedAppLog.evidenceLink = evidenceLink;
				selectedAppLog.linkedEntryId = linkedEntryId;
				selectedAppLog.updatedBy = datastore.ownerInformation.name;
				if (sourceId && (selectedBillItem === 'Update from mail' || selectedBillItem === 'Update from email')) {
					selectedAppLog.sourceId = sourceId;
					selectedAppLog.sourceDocumentType = sourceDocumentType;
					selectedAppLog.documents = Array.isArray(isVerified) ? isVerified : isVerified?.attachmentDetails ? Array.isArray(isVerified?.attachmentDetails) ? isVerified?.attachmentDetails : [isVerified?.attachmentDetails?.name] : [];
				} else{
					selectedAppLog.sourceId = '';
					selectedAppLog.sourceDocumentType = '';
					selectedAppLog.documents = [];
				}
				if (documentId && (selectedBillItem === 'Trigger due to property addition' || selectedBillItem === 'Trigger due to periodic update')) {
					selectedAppLog.documentId = documentId;
				} else{
					selectedAppLog.documentId = '';
				}
				updateLogLoading(true);
				const response = await dashboardServices.updateLogs(selectedAppLog);
				updateLogLoading(false);

				if(response && response.status == 200) {
					setReloadFutureEffectiveDateLog(true);
					copyOfLogs[selectedAppLogIndex] = selectedAppLog;
					setAppLogs({
						...appLogs,
						data: copyOfLogs
					})

					if(datastore.createdLogs[selectedAppLog.tagTypeId]){
						let tempLogs = {...datastore.createdLogs[selectedAppLog.tagTypeId]};
						tempLogs.data = copyOfLogs;
						datastore.createdLogs[selectedAppLog.tagTypeId] = tempLogs;
					}

					if(Array.isArray(response.data.updatedConnectedLogs) && response.data.updatedConnectedLogs.length > 0) {
						response.data.updatedConnectedLogs.map((updatedLog: any) => {
							if(Array.isArray(datastore.createdLogs[updatedLog.tagTypeId]) && datastore.createdLogs[updatedLog.tagTypeId].length > 0) {
								for(let i=0; i<datastore.createdLogs[updatedLog.tagTypeId].data.length; i++) {
									if(datastore.createdLogs[updatedLog.tagTypeId].data[i].objectId === updatedLog.objectId) {
										datastore.createdLogs[updatedLog.tagTypeId].data[i].billItem = updatedLog.billItem;
									}
								}
							}
						});
					}
				}
			}
		}
	}

	const renderEvents = (row:any) => {
		if (!row || !Array.isArray(row.events) || row.events.length == 0) {
			<></>
		}

		const onboardingEvents:any = [];
		const otherEvents:any = [];

		for (const event of row.events) {
			if (event === "Client Directory" || event === "Portal Search" || event === "Email HOA" || event === "Call HOA") {
				onboardingEvents.push(event);
			}
			else {
				otherEvents.push(event);
			}
		}

		return (
			<div>
				<div style={{marginTop: '8px'}}>
				{
					otherEvents.length > 0 && otherEvents.map((event: any) => (
						<span className="text-5B5B5B-14px normal" style={{marginTop: '8px'}}>
							<span className="text-capitalized">{event.split("(")[0]}</span>
							<span>{event?.split("(")[1] ? `(${event.split("(")[1]}` : ""}</span>
						</span>
					))
					.reduce((prev: any, curr: any) => [prev, ', ', curr])
				}
				</div>
				<div style={{ display: "flex", flexFlow: "wrap", marginBottom: '8px' }}>
				{
					onboardingEvents.length > 0 && onboardingEvents.map((event: any) => (
						<div className="text-5B5B5B-14px normal" style={{marginTop: '8px', marginRight: "4px", background: "#EFF4FC", border: "1px solid #E8E8E8", padding: "6px", width: "fit-content", borderRadius: "4px"}}>
							<span className="text-capitalized">{event}</span>
						</div>
					))
				}
				</div>
			</div>
		)
	}

	function MouseOver(event: any) {
        event.target.style.color = '#3576E5';
    }
    function MouseOut(event: any) {
        event.target.style.color = "";
    }

	const urlCheck = (url: string) => {
		if (url) {
			return url.match(/^http[s]?:\/\//) ? url : 'http://' + url;
		}
		return "";
	}

	const isValidDocumentUrl = (url: string) => {
		return url && url.includes('hoa-dashboard');
	}

	const downloadDocument = async (fileUrl: string) => {
        if(!fileUrl || !isValidDocumentUrl(fileUrl)) {
            return;
        }

		fileUrl = urlCheck(fileUrl);

		let extractUrl = fileUrl.split('?')[0];
		let extractUrlArray = extractUrl.split('/');
		let fileName = decodeNestedURI(extractUrlArray[extractUrlArray.length-1]);
		let path = `${hoaPath}/${extractUrlArray[4]}/documents/${extractUrlArray[6].replace(/ /g, "-")}/${fileName}`;

        const documentUrl = await dashboardServices.getSignedUrl(path);

        if(documentUrl && documentUrl.data) {
            window.open(String(documentUrl.data), '_blank');
        }
    }
	
	const renderEvidenceLinks = (evidenceLink: string, downloadDocument: any) => {
		if(!evidenceLink) {
			return (<>N/A</>)
		}
		else {
			return (
				<>{evidenceLink}</>
			)
		}
	}

	const shouldApplyBorderTop = (index: any) => {
		if (!appLogs.data || !Array.isArray(appLogs.data)) {
			return false;
		}

		if (index == appLogs.data.length - 1) {
			return false;
		}
		else if (index == 0) {
			if (appLogs.data.length > 1 && appLogs.data[0].eventGroupId && appLogs.data[0].eventGroupId == appLogs.data[1].eventGroupId) {
				return true;
			}
			else {
				return false;
			}
		}
		else if (appLogs.data[index].eventGroupId && appLogs.data[index].eventGroupId != appLogs.data[index-1].eventGroupId && appLogs.data[index].eventGroupId == appLogs.data[index+1].eventGroupId) {
			return true;
		}

		return false;
	}

	const shouldApplyBorderBottom = (index:any) => {
		if (!appLogs.data || !Array.isArray(appLogs.data)) {
			return false;
		}

		if (appLogs.data.length == 1) {
			return false;
		}
		else if (index == 0) {
			return false;
		}
		else if (index == appLogs.data.length - 1) {
			if (appLogs.data[index].eventGroupId && appLogs.data[index].eventGroupId == appLogs.data[index-1].eventGroupId) {
				return true;
			}
			else {
				return false;
			}
		}
		else if (appLogs.data[index].eventGroupId == appLogs.data[index-1].eventGroupId && appLogs.data[index].eventGroupId != appLogs.data[index+1].eventGroupId) {
			return true;
		}

		return false;
	}

	const shouldApplyBorderSides = (index:any) => {
		if (appLogs.data.length == 1) {
			return false;
		}
		else if (index == 0) {
			if (appLogs.data[index].eventGroupId && appLogs.data[index].eventGroupId == appLogs.data[index+1].eventGroupId) {
				return true;
			}
			else {
				return false;
			} 
		}
		else if (index == appLogs.data.length - 1) {
			if (appLogs.data[index].eventGroupId && appLogs.data[index].eventGroupId == appLogs.data[index-1].eventGroupId) {
				return true;
			}
			else {
				return false;
			}
		}
		else if (appLogs.data[index].eventGroupId && (appLogs.data[index].eventGroupId == appLogs.data[index-1].eventGroupId || appLogs.data[index].eventGroupId == appLogs.data[index+1].eventGroupId)) {
			return true;
		}

		return false;
	}

	const handleFilterClick = () => {
		setAnchorEl(buttonRef.current);
	}

	const shouldShowEffectiveDateSign = (dataRow:any) => {
		return (
			dataRow.effectiveDate && dataRow.billItem != 'Not Billable'
		)
	}

	const downloadDocumentByDocumentId = async (e:any, documentId: any) => {
		e.stopPropagation();

		setDOcumentViewModal(true)
		let {data} = await dashboardServices.getDocumentDetailsByDocumentId(documentId)
		setDocumentData(data)
	}

	const handleDocumentViewModalClose = () => {
		setDocumentData([]);
		setDOcumentViewModal(false);
	}

	return datastore.isUserPermitted(type,'view') && (
		<div style={{ margin: "24px 24px 0 24px" }}>
			<DocumentModalComp 
				docModalOpen={docModalOpen}
				handleDocModalClose={handleDocModalClose}
				sourceDocuments={sourceDocuments}

			/>
			<DocumentViewModal 
				documentViewModal={documentViewModal} 
				handleDocumentViewModalClose={handleDocumentViewModalClose}
				documentData={documentData}
			/>
			<BillableItemsModal
			    billItems={datastore.billableItemsOptions[type ? type.toLowerCase() : ""]}
				selectedBillItem={selectedBillItem}
                setSelectedBillItem={setSelectedBillItem}
                evidenceLink={evidenceLink}
                setEvidenceLink={setEvidenceLink}
				sourceId={sourceId}
				setSourceId={setSourceId}
				isVerified={isVerified}
				setIsVerified={setIsVerified}
				sourceDocumentType={sourceDocumentType}
				setSourceDocumentType={setSourceDocumentType}
                onSaveClick={updateHoaApplog}
                isBillableItemsModal={isBillableItemsModal}
                setIsBillableItemsModal={setIsBillableItemsModal}
                documentType={documentType}
                setDocumentType={setDocumentType}
                tagType={type} 
                setLoading={updateLogLoading}
                view={'add'}
				isEditMode={true}
				isOtherBillableItemsDisabled={isOtherBillableItemsDisabled}
				linkedEntryId={linkedEntryId}
				setLinkedEntryId={setLinkedEntryId}
				documentId={documentId}
				setDocumentId={setDocumentId}
				isDocumentIdVerified={isDocumentIdVerified}
				setIsDocumentIdVerified={setIsDocumentIdVerified}
			/>
			{
				open &&
				<ChangeLogChangeState 
					open={open}
					onClose={handleClose}
					log={selectedLog}
					type={type}
				/>
			}
			<div style={{ display: 'flex', width: '100%', justifyContent: "space-between", marginBottom: '24px' }}>
				<span className="text-3E3E3E-18px">Change Log</span>
				<Button
					id="end-filtering-icon-title"
					ref={buttonRef}
					onClick={handleFilterClick}
					style={{ minWidth: '98px', height: '100%', padding: '0px', textTransform: 'capitalize' }}
					startIcon={<FilterList style={{ color: '#9F9F9F' }} />}>
					Filter
				</Button>
			</div>
			{isLogLoading ? <LinearProgress style={{ height: "2px",position: 'sticky', top: 0 }} /> : null}
			<div style={{height: height, overflowY: 'auto' }} onScroll={(e)=>{handleScroll(e)}}>
				<table  style={{width: '2000px', borderCollapse: 'collapse'}}>
					<thead style={{ margin: "0 auto" }}>
						<tr className="table-header">
							{["", "Entry ID", "Organization Name", "Billable Item", "Effective Date", "Timestamp", "Events", "Username", "Source ID", "Remarks", "Document ID", "Document Type", "Linked Entry ID", "Updated By", ""].map(
								(header: string, index: number) => {
									return (
										<th
											key={header}
											style={{
												background: "#EFF4FC",
												width: tabWidth[index],
												wordBreak: 'break-word',
												position: 'sticky',
												top: 0
											}}
											className="table-header-title-container"
										>
											{header}
										</th>
									);
								}
							)}
						</tr>
					</thead>
					<tbody
						style={{
							// height: `${window.innerHeight - responsiveHeight}px`,
							width: "calc( 100% + 2px)",
							overflow: "auto",
							borderBottom: "1px solid #E8E8E8",
							borderRadius:'4px',
							paddingBottom:'2px',
						}}
					>
						{appLogs.data.map((row: any, index: number) => {
							if(row && row.objectId) {
								return (
									<tr key={index} className="table-body" onClick={() => changeStateModal(row)}
										style={{ 
											borderTop: shouldApplyBorderTop(index) ? "1px solid #000" : "",
											borderBottom: shouldApplyBorderBottom(index) ? "1px solid #000" : "",
											borderLeft: shouldApplyBorderSides(index) ? "1px solid #000" : "",
											borderRight: shouldApplyBorderSides(index) ? "1px solid #000" : "",
										}}
									>
										<td
											style={{
												width: tabWidth[0],
											}}
											className="table-body-container"
										>
											{shouldShowEffectiveDateSign(row) && <InfoIcon style={{ color: "orange" }}/>}
										</td>
										<td
											style={{
												width: tabWidth[1],
											}}
											className="table-body-container"
										>
											{row.objectId}
										</td>
										<td
											style={{
												width: "8%",
												wordBreak: 'break-word'
											}}
											className="table-body-container"
										>
											{row.organizationName}
										</td>
										<td
											style={{
												width: tabWidth[3],
												paddingLeft: "20px",
												wordBreak: 'break-word'
											}}
											className="table-body-container"
										>
											{row.billItem}
										</td>
										<td
											style={{
												width: "7%",
												paddingLeft: "20px"
											}}
											className="table-body-container"
										>
											{row.formattedEffectiveDate}
										</td>
										<td
											style={{
												width: tabWidth[5],
												paddingLeft: "18px",
												wordBreak: 'break-word'
											}}
											className="table-body-container"
										>
											{row.createdAt}
										</td>
										<td
											style={{
												width: tabWidth[6],
												wordBreak: 'break-word',
												paddingLeft: "18px"
											}}
											className="table-body-container text-capitalized"
										>
											{renderEvents(row)}
										</td>
										<td
											style={{
												width: tabWidth[7],
												paddingLeft: '18px',
												wordBreak: 'break-word'
											}}
											className="table-body-container"
										>
											{datastore.userRole === config.userRoles.OrganizationUser ? 'N/A' : row?.user}
										</td>
										<td
											style={{
												width: tabWidth[8],
												paddingLeft: '18px'
											}}
											className="table-body-container"
										>
											{row?.sourceId ? row.sourceId : 'N/A'}
										</td>
										<td
											style={{
												width: tabWidth[9],
												paddingLeft: '18px'
											}}
											className="table-body-container"
										>
											{renderEvidenceLinks(row.evidenceLink, downloadDocument)}
										</td>
										<td
											style={{
												width: tabWidth[8],
												paddingLeft: '18px'
											}}
											className="table-body-container"
										>
											{row?.documentId ? row.documentId : 'N/A'}
										</td>
										<td
											style={{
												width: tabWidth[10],
												paddingLeft: '18px'
											}}
											className="table-body-container"
										>
											{row.documentType}
										</td>
										<td
											style={{
												width: tabWidth[11]
											}}
											className="table-body-container"
										>
											{row.linkedEntryId}
										</td>
										<td
											style={{
												width: tabWidth[12]
											}}
											className="table-body-container"
										>
											{row.updatedBy}
										</td>
										<td
											style={{
												width: tabWidth[13],
												display:"flex",
												flexDirection:"row"
											}}
											className="table-body-container icon-container-hover"
										>
											{type == "Hoa" && row?.documentId &&
												<Tooltip title="Document">
													<IconButton onClick={(e)=> downloadDocumentByDocumentId(e, row?.documentId)} onMouseOver={MouseOver} onMouseOut={MouseOut}>
														<DescriptionIcon id='icon-componenet' />
													</IconButton>
												</Tooltip>
											}
											{(type == "Hoa" || type == "Property") && Array.isArray(row?.documents) && row?.documents.length>0 &&
												<Tooltip title="Documents">
													<IconButton onClick={(e) => handleDocModalOpen(e,row)} onMouseOver={MouseOver} onMouseOut={MouseOut}>
														<DescriptionIcon id='icon-componenet' />
													</IconButton>
												</Tooltip>
											}
											{(type == "Hoa" || type == "Property" || type == "Municipality") && datastore.isUserPermitted(type,'log_update') &&
												<Tooltip title="Edit">
													<IconButton onClick={(e) => appLogClicked(e,row)} onMouseOver={MouseOver} onMouseOut={MouseOut}>
														<Edit id='icon-componenet' />
													</IconButton>
												</Tooltip>
											}
										</td>
									</tr>
								)
							}
						})}
					</tbody>
				</table>
			</div>
			{FilterPopUp(anchorEl, setAnchorEl, getCreatedLogs, appLogs, setAppLogs, documentType, setDocumentType, startDate, setStartDate, endDate, setEndDate, linkedEntryId, setLinkedEntryId)}
		</div>
	);
}

const FilterPopUp = (anchorEl:any, setAnchorEl:any, getCreatedLogs: any, appLogs: any, setAppLogs: any, documentType: any, setDocumentType: any,startDate: any, setStartDate: any,endDate: any, setEndDate: any, linkedEntryId: any, setLinkedEntryId: any) => {
	const onClose = () => {
		setAnchorEl(null);
	}

	const onClear = async () => {
		setDocumentType('');
		setStartDate(null);
		setEndDate(null);
		setLinkedEntryId(null);
		onClose();
		setAppLogs({
			...appLogs,
			data: []
		});
		const options = {
			...(datastore.selectedOrganization?.id ? { 'orgId': datastore.selectedOrganization?.id } : {}),
		}
		await getCreatedLogs(1, options);
	}

	const onCancel = () => {
		setAnchorEl(null);
	}

	const onApplyFilter = async () => {
		onClose();
		const options = {
			...(datastore.selectedOrganization?.id ? { 'orgId': datastore.selectedOrganization?.id } : {}),
			...(documentType ? { 'documentType': documentType } : {}),
			...(linkedEntryId ? { 'linkedEntryId': linkedEntryId } : {}),
			...(startDate ? { 'startEffectiveDate': startDate } : {}),
			...(endDate ? { 'endEffectiveDate': endDate } : {})
		  }
		await getCreatedLogs(1, options);
	}

	return (
			<Popover
				open={anchorEl ? true : false}
				anchorEl={anchorEl}
				onClose={() => onClose()}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'right',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
				PaperProps={{
					elevation: 0,
					style: {
						marginTop:'10px',
						width: '589px',
						maxHeight: '520px',
						filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
						background: '#FFFFFF',
						border: '1px solid #E8E8E8',
						boxShadow: '0px 10px 26px rgba(0, 0, 0, 0.2)',
						borderRadius: '8px'
					}
				}}
			>
            <main style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
				<div  style={{ width: 'calc(100% - 48px)', borderBottom: '1px solid  #F7F7F7', marginTop: '24px' }}>
                    <div style={{ justifyContent: 'flex-start', alignItems: 'baseline'}} className='advance-filter-container'>
						<span className="filter-field-title-comp" style={{ margin: '2px 10px 0px 0px', width: "100px", wordBreak: 'break-word' }}>Document Type</span>
						<FormControl variant="standard" style={{ width: "380px" }}>
							<InputLabel id="demo-simple-select-standard-label">Document Type</InputLabel>
							<Select
								labelId="demo-simple-select-standard-label"
								id="demo-simple-select-standard"
								value={documentType}
								onChange={(e) => setDocumentType(e.target.value)}
								label="Document Type"
							>
								{config.billableItemModalDocumentType.map((item:any) => {
									return (
										<MenuItem value={item}>{item}</MenuItem>        
									)
								})}
							</Select>
						</FormControl>
                    </div>

					<div style={{ width: 'calc(100% - 48px)', marginTop: '24px' }}>
						<div style={{ alignItems: 'baseline' }} className='advance-filter-container'>
							<span className="filter-field-title-comp" style={{ margin: '2px 10px 0px 0px', width: "100px", wordBreak: 'break-all' }}>Effective Date</span>
							<CustomDateField 
								label="Start Date"
								error={false}
								variant="standard"
								style={{width: '184px', margin: "2px"}}
								value={dayjs(startDate || null)}
								handleChange={(value: any) =>{
									setStartDate(value);
								}}
							/>
							<CustomDateField 
								label="End Date"
								error={false}
								variant="standard"
								style={{width: '184px', margin: "2px"}}
								value={dayjs(endDate || null)}
								handleChange={(value: any) =>{
									setEndDate(value);
								}}
							/>
						</div>
					</div>

					<div style={{ justifyContent: 'flex-start', alignItems: 'baseline'}} className='advance-filter-container'>
						<span className="filter-field-title-comp" style={{ margin: '2px 10px 0px 0px', width: "100px", wordBreak: 'break-word' }}>Linked Entry ID</span>
						<FormControl variant="standard" style={{ width: "380px" }}>
							<TextField
								style={{ width: "380px" }}
								margin="dense"
								id="linkedEntryId"
								label="Linked Entry ID"
								type="linkedEntryId"
								fullWidth
								variant="standard"
								value={linkedEntryId}
								onChange={(e) => setLinkedEntryId(e.target.value)}
							/>
						</FormControl>
                    </div>
                </div>
                <div className="filter-footer">
                    <Button onClick={()=> onClear()} startIcon={<DeleteOutlineSharpIcon style={{ color: '#3576E5' }} />} id='clear-all-btn'><span id='btn-title'>Clear All</span></Button>
                    <div>
                        <Button onClick={()=> onCancel()} id='cancel-btn'><span id='btn-title'>Cancel</span></Button>
                        <Button onClick={()=> onApplyFilter()} variant="contained" id='apply-btn'><span style={{ color: 'white' }} id='btn-title'>Apply Filter</span></Button>
                    </div>
                </div>
            </main>
        </Popover>
	)
}


const ChangeLogChangeState = ({open, onClose, log, type}: any) => {
	const [changeState, setChangeState] = useState<any>({});
	const [events, setEvents] = useState([]);
	const [eventId, setEventId] = useState('');

	useEffect(() => {
		if(log) {
			let {changes, events} = getChange(log);
			setChangeState(changes);
			setEvents(events);
			setEventId(log.objectId);
		}
	},[log])

	const copyToClipboard = (text: string) => {
		navigator.clipboard.writeText(text)
		alert("Copied to clipboard!");
	};

	return (
		<Modal open={open} onClose={onClose}>
        <Container
            style={{
                background: "white",
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                maxHeight: "645px",
                overflow: "auto",
                borderRadius: "8px 8px 0px 0px",
                padding: "0px",
                overflowX: 'hidden'
            }}
        >
            <div style={{background: "#EFF4FC", display: 'flex', justifyContent: 'space-between'}}>
                <div className="modal-title-container">
                    <span className="text-3E3E3E-20px bold">Event Change Log</span>
                        {events && events.map(event => (
							<span className="text-5B5B5B-14px  normal" style={{marginTop: '8px'}}>
								<span className="text-capitalized">{event.split("(")[0]}</span>
								<span>{event?.split("(")[1] ? `(${event.split("(")[1]}` : ""}</span>
							</span>
						))}
					<span className="text-5B5B5B-14px  normal" 
					style={{
						marginTop: '8px',
						border: '1px solid #E8E8E8',
						padding: '12px',
						maxWidth: 'fit-content',
						backgroundColor: '#E8E8E8'}}>
                        Entry ID: {eventId}
                    </span>
                </div>
            <div style={{padding: '24px', cursor: 'pointer'}} onClick={onClose}>
                <CloseIcon />
            </div>
            </div>
            <Card
                variant="outlined"
                className="violation-card-container"
            >
				<table className="table-container">
					<thead style={{ margin: "0 auto" }}>
						<tr className="table-header">
							{["Keys", "Values"].map(
								(header: string, index: number) => {
									return (
										<th
											key={header}
											style={{
												background: "#EFF4FC",
												width: changeStateTabWidth[index],
											}}
											className="table-header-title-container"
										>
											{header}
										</th>
									);
								}
							)}
						</tr>
					</thead>
					<tbody
						style={{
							height: `${window.innerHeight - responsiveHeight}px`,
							width: "calc( 100% + 2px)",
							overflow: "auto",
							borderBottom: "1px solid #E8E8E8",
							borderRadius:'4px',
							paddingBottom:'2px',
						}}
					>
                    {Object.keys(changeState).length > 0 && Object.keys(changeState).map(
                        (row: any, index: number) => {
							return (
								<tr key={index} className="table-body">
								<td
									style={{
										width: changeStateTabWidth[0],
										textTransform: 'capitalize',
										cursor:'copy'
									}}
									className="table-body-container"
									onClick={() => copyToClipboard(row)}
								>
									{row.split(/(?=[A-Z])/).join(' ')}
								</td>
								<td
									style={{
										width: changeStateTabWidth[1],
									}}
									className="table-body-container"
								>
									<JsonView value={changeState[row]} collapsed={true} displayDataTypes={false} enableClipboard={false} />
								</td>
								</tr>
							);
                        }
                    )}
					</tbody>
				</table>
            </Card>
        </Container>
        </Modal>
	)
}

const DocumentModalComp = ({docModalOpen, handleDocModalClose, sourceDocuments}: any) => {

	const DownloadDoc = async (name: string) => {
		let path = '';
		if(sourceDocuments.sourceDocumentType === 'mail') {
			path = `hoaMails/${name}`;
			const url =  await dashboardServices.getSignedUrl(path, '', true);
			window.open(url.data, "_blank");
		}else{
			path = `hoaEmails/${name}`;
			const url =  await dashboardServices.getSignedUrl(path);
			window.open(url.data, "_blank");
		}
	};

	return (
		<Modal disableEnforceFocus open={docModalOpen} onClose={handleDocModalClose}>
			<Container
				style={{
					background: "white",
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
					width: "auto",
					maxHeight: "645px",
					overflow: "auto",
					borderRadius: "8px",
					padding: "0px",
				}}
			>
				<div className="modal-wrapper-doc">
					<div style={{display: 'flex', justifyContent: 'space-between'}}>
						<h3 style={{color: '#3E3E3E'}}>Source Documents</h3>
						<IconButton
							onClick={() => handleDocModalClose()}>
							<CloseIcon
								style={{cursor: "pointer"}}
							/>
						</IconButton>
					</div>
					<table className='table-container'>
						<thead style={{ margin: '0 auto' }}>
							<tr className="table-header">
								<th className="table-header-title-container">Name</th>
								<th className="table-header-title-container"></th>
							</tr>
						</thead>
						<tbody style={{ height: 'auto', width: 'auto' }}>
							{sourceDocuments?.documents && sourceDocuments.documents.map((row: any, index: number) => (
								<tr className="table-body" key={index}>
									<td className="table-body-container">{row}</td>
									<td className="table-body-container">
										<IconButton
											onClick={() => {
												DownloadDoc(row);
											}}>
											<DownloadIcon
												style={{
													width: "20px",
													height: "20px",
													cursor: "pointer",
												}}
											/>
										</IconButton>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</Container>
		</Modal>
	)
}

const DocumentViewModal = ({documentViewModal, handleDocumentViewModalClose, documentData}: any) => {

	const DownloadDoc = async (data: any) => {
		 if(!data || !data.attachmentKey || !data.addedBy) {
				return;
		}
	
		let downloadKey = data.attachmentKey;
		let bucketName = '';
	
		if (data.addedBy === 'HPA') {
			bucketName = 'im-hoa-hpa';
		}
		else if (data.addedBy === 'Bridge Homes') {
			bucketName = 'im-bridge';
		} 
		else {
			bucketName = 'im-hoa';
		}
	
		const isPdf = data.attachmentKey.includes('.pdf') ? true : false;
	
		const documentUrl = await dashboardServices.getSignedUrl(downloadKey, bucketName, isPdf);
	
		if(documentUrl && documentUrl.data) {
			window.open(String(documentUrl.data), '_blank');
		}
	};

	return (
		<Modal disableEnforceFocus open={documentViewModal} onClose={handleDocumentViewModalClose}>
			<Container
				style={{
					background: "white",
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
					maxHeight: "645px",
					overflow: "auto",
					borderRadius: "8px",
					padding: "0px",
					width:"auto",
					minWidth: "450px",
					maxWidth: "550px"
				}}
			>
				<div className="modal-wrapper-doc">
					<div style={{display: 'flex', justifyContent: 'space-between'}}>
						<h3 style={{color: '#3E3E3E'}}>Documents</h3>
						<IconButton
							onClick={() => handleDocumentViewModalClose()}>
							<CloseIcon
								style={{cursor: "pointer"}}
							/>
						</IconButton>
					</div>
					<table className='table-container'>
						<thead style={{ margin: '0 auto' }}>
							<tr className="table-header">
								<th className="table-header-title-container">Name</th>
								<th className="table-header-title-container"></th>
							</tr>
						</thead>
						<tbody style={{ height: 'auto', width: 'auto' }}>
							{documentData.length === 0 ? <LinearProgress/> : 
							 documentData.map((row: any, index: number) => (
								<tr className="table-body" key={index}>
									<td className="table-body-container">{row?.attachmentKey}</td>
									<td className="table-body-container">
										<IconButton
											onClick={() => {
												DownloadDoc(row);
											}}>
											<DownloadIcon
												style={{
													width: "20px",
													height: "20px",
													cursor: "pointer",
												}}
											/>
										</IconButton>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</Container>
		</Modal>
	)
}